import React, { useEffect, useState } from "react";
import { useAppSelector } from "../lib/hook";
import { store } from "../lib/store";
import { Outlet } from "react-router-dom";
import LoadingComponent from "../components/loading/LoadingComponent";
import { refreshToken } from "../lib/features/user-auth/userAuth.thunk";

interface PersistLoginContextProps {
  // Add props here
}

const PersistLoginContext: React.FC<PersistLoginContextProps> = () => {
  const [loading, setLoading] = useState(true);

  const isLogin = useAppSelector((store) => store?.userAuth?.data);
  const verifyRefreshToken = async () => {
    try {
      await store.dispatch(refreshToken());
    } catch (err) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      isLogin === null ? verifyRefreshToken() : setLoading(false);
    }
    return () => {
      mounted = false;
    }; 
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return loading ? (
    <LoadingComponent />
  ) : (
    <>
      <Outlet />
    </>
  );
};

export default PersistLoginContext;
